import { PermissionsEnum } from "@/auth/interfaces";
import { TABLE_CONSTANTS } from "@/shared";
import { GeneralTable } from "@/shared/components/ui";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import CustomSearchFilterSupervisorVenta from "@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import VisibilityIcon from '@mui/icons-material/Visibility';
import useTableColumnsSolicitudTecnicoPymes from "../../hook/useTableColumnsSolicitudTecnicoPymes";
import { useNavigate } from "react-router-dom";
import { useFetchPreagendamientosPymes } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";


interface TableSolicitudPreagendamientoTecnicoPymesProps {
  router_path: string
  provincia_exclude?: string
  provincia_in?: string
}

const TableSolicitudPreagendamientoTecnicoPymes = ({
  provincia_exclude,
  provincia_in,
  router_path
}: TableSolicitudPreagendamientoTecnicoPymesProps) => {

  const navigate = useNavigate();

  useCheckPermissions(PermissionsEnum.api_view_preagendamiento);


  ///* Hook
  const {
    columnaSolicitudTecnicoPymes
  } = useTableColumnsSolicitudTecnicoPymes()

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
    vendedor,
    setVendedor

  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  ///* React Query

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } =
    useTableServerSideFiltering();

  const {
    isLoading,
    data: agendaRes,
    isRefetching
  } = useFetchPreagendamientosPymes(
    {
      enabled: true,
      params: {
        //estado_preagendamiento_in: EstadosPreagendamientoEnumChoice.PENDIENTE_TECNICO,
        identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: pageSize,
        fecha_after: dateAfter,
        fecha_before: dateBefore,
        user_create: vendedor,
        solicitar_tecnico: true,
        provincia_exclude,
        provincia_in,
        ...filterObject,
        filterByState: false
      }
    }
  );


  return (
    <>
      <Grid container spacing={2} >

        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
            setVendedor={setVendedor}
          //vendedor={vendedor}

          />
        </Grid>


        <Grid item xs={12}>
          <GeneralTable<IPreagendamientoPymes>
            columns={columnaSolicitudTecnicoPymes}
            data={agendaRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={agendaRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canEdit={false}
            showCustomActionBtnSpace={true}
            enableColumnActions={true} /// 
            enableEditing={true}

            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
            customActionBtnSpace={(value) => {
              //console.log(value)
              return (
                <Grid container>

                  <Grid item>
                    <Tooltip title={'Solicitud'} placement="top">
                      <IconButton
                        onClick={() => {
                          navigate(`${router_path}/${value.id_preagendamiento_pymes}`)
                        }
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                </Grid>
              )
            }}
          />
        </Grid>
      </Grid >


    </>
  );

}

export default TableSolicitudPreagendamientoTecnicoPymes;